import React from 'react'

import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import { IAttachment } from '~/client/graph'

import { getAttachmentFileIcon } from '../WorkflowCard/fileAttachmentHelpers'

interface IProps {
  attachment: IAttachment
  className?: string
}

@observer
export default class AttachmentTag extends React.Component<IProps> {
  public render(): React.ReactNode {
    const { className, attachment } = this.props
    return (
      <div
        className={classList({
          row: true,
          [className]: !!className,
        })}
      >
        {getAttachmentFileIcon(attachment.fileName, 'w20 h20 no-flex mr10')}
        <div className="text large" title={attachment.fileName}>
          {attachment.fileName}
        </div>
      </div>
    )
  }
}
